/**
 * USER ROLE CELL
 * Rôle d'un compte dans l'écran Utilisateurs (modifiable, sauf superadmin).
 * Un compte sans rôle CRM n'a accès à aucune donnée (TICKET-SEC-07, 00308) :
 * il s'affiche « Sans rôle », et choisir un rôle le lui donne directement.
 */

import { TableCell } from '@/components/table';
import { Select } from '@/components/ui/select';
import { getExplicitRole } from '@/lib/permissions';
import type { UserRole, UserRoleOrNone } from '@/types/user';
import { NO_ROLE_LABEL, USER_ROLES, USER_ROLE_LABELS } from '@/types/user';

interface UserRoleCellProps {
  role: UserRoleOrNone;
  onChange: (role: UserRole) => void;
}

export function UserRoleCell({ role, onChange }: UserRoleCellProps) {
  // Ne pas permettre la modification du rôle superadmin
  if (role === 'superadmin') {
    return <TableCell className="font-semibold text-purple-600">Super Admin</TableCell>;
  }

  const explicitRole = getExplicitRole(role);

  return (
    <div className="flex items-center">
      <Select
        variant="inline"
        value={explicitRole ?? ''}
        onChange={(e) => onChange(e.target.value as UserRole)}
      >
        {!explicitRole && (
          <option value="" disabled>
            {NO_ROLE_LABEL}
          </option>
        )}
        {USER_ROLES.map((r) => (
          <option key={r} value={r}>
            {USER_ROLE_LABELS[r]}
          </option>
        ))}
      </Select>
    </div>
  );
}
